/**
 * Small "what is this and how is it calculated" hint — an info icon that
 * reveals `text` on hover/focus. Shared across every Absence Insights KPI
 * card and chart heading, so it lives in its own file rather than adding
 * more lines to AbsenceInsightsCharts.tsx (already at the repo's max-lines
 * lint limit).
 */
import { Info } from 'lucide-react';

export function InfoTooltip({ text }: { text: string }) {
  return (
    <span className="group relative ml-1 inline-flex align-middle normal-case">
      <button
        type="button"
        aria-label={text}
        className="flex h-3.5 w-3.5 items-center justify-center rounded-full text-zinc-400 hover:text-zinc-600 focus:outline-none focus-visible:ring-1 focus-visible:ring-sky-400"
      >
        <Info className="h-3.5 w-3.5" aria-hidden="true" />
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 top-full z-30 mt-1.5 w-64 -translate-x-1/2 whitespace-normal rounded-md border border-zinc-200 bg-white p-2.5 text-[11px] font-normal leading-snug text-zinc-600 opacity-0 shadow-lg transition-opacity duration-100 group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {text}
      </span>
    </span>
  );
}
